/* eslint-disable no-unused-vars */
export enum ButtonSizes {
  LARGE = 'large',
  SMALL = 'small',
}
